// import React, { useEffect, useState } from "react";
// import styles from "./Product.module.css";
// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
// import { useAuth } from "../../components/context/Auth";
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import {
//   AddTO, DeleteTo, EditeTo,
//   SettingTo, ViewTo,
// } from "../../components/icons/Icon3";
// import fetchData from "../../APIsControll/apiControll";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
// import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
// import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
// import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
// import { TextColorCode } from "../../Utils/TextUtils";
// import { useNavigate } from "react-router-dom";
// import { TemplateNotFound } from "../../components/icons/Icon2";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// import useWindowWidth from "../../components/updatedComponents/Hooks/WidthSize";

// const Products = () => {
//   const { mode, managerId } = useAuth();
//   const { show } = useToast();
//   const navi = useNavigate();
//   const [loading, setLoading] = useState({
//     productLoading: false,
//     productDelete: false,
//   });
//   const [sortBy, setSortBy] = useState(null);
//   const [statusFilter, setStatusFilter] = useState("");
//   const [productSearch, setProductSerach] = useState('');
//   const width = useWindowWidth();
//   const [toggle, setToggle] = useState({
//     modelToggle: false,
//   });
//   const [ProductData, setProductData] = useState([]);
//   const [modelContainer, setModeContiner] = useState(null);
//   const [filteredData, setFilteredData] = useState([]);

//   const filterAndSort = () => {
//   let data = [...ProductData];

//   // Filter by product name
//   if (productSearch) {
//     data = data.filter((product) =>
//       product.product_name.toLowerCase().includes(productSearch.toLowerCase())
//     );
//   }

//   // Filter by status (Active / Disable)
//   if (statusFilter) {
//     data = data.filter((product) => product.status === statusFilter);
//   }

//   // Sort logic
//   if (sortBy) {
//     data.sort((a, b) => {
//       if (sortBy === "status") {
//         return a.status.localeCompare(b.status);
//       } else {
//         if (a[sortBy] < b[sortBy]) return -1;
//         if (a[sortBy] > b[sortBy]) return 1;
//         return 0;
//       }
//     })}
//   setFilteredData(data);
// };

//   useEffect(() => {
//     filterAndSort();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [productSearch, sortBy]);


//   const getAllProduct = async () => {
//     try {
//       setLoading({ ...loading, productLoading: true });
//       const res = await fetchData(`content/products`);
//       if (res.status === "success") {
//         setProductData(res.data);
//         setFilteredData(res.data);
//         return;
//       }
//       if (res.status === "failed") {
//         show(res.msg, "error");
//       }
//     } catch (error) {
//       show("Error fetching products", "error");
//     } finally {
//       setLoading({ ...loading, productLoading: false });
//     }
//   };

//   const DeleteProduct = async (id) => {
//     try {
//       const payload = {
//         managerId: managerId,
//         _id: id,
//       };
//       setLoading({ ...loading, productDelete: true });
//       const res = await fetchData(`content/deleteProduct`, payload);
//       if (res.status === "success") {
//         show(res.msg, "success");
//         getAllProduct();
//         return;
//       }
//       if (res.status === "failed") {
//         show(res.msg, "error");
//         return;
//       }
//     } catch (error) {
//       show("Something went wrong", "error");
//     } finally {
//       setLoading({ ...loading, productDelete: false });
//     }
//   };

//   useEffect(() => {
//     getAllProduct();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [managerId]);

//   const handleSetModel = (con) => {
//     setToggle({ ...toggle, modelToggle: true });
//     setModeContiner(con);
//   };

//   return (
//     <div className={styles.Main_Layout}>
//       <ModalWrapper
//         isOpen={toggle.modelToggle}
//         onClose={() => setToggle({ ...toggle, modelToggle: !toggle.modelToggle })}
//       >
//         {modelContainer}
//       </ModalWrapper>

//       <div className={styles.Layout}
//         style={{ backgroundColor: mode ? "#2B2D31" : "#F8F9FC" }}
//       >
//         <div className={styles.Top_bar_css}>
//           <div className={styles.gobackClass}>
//             <TopTabBar text={"Product"} />
//           </div>
//           <div className={styles.btn_Continer}>
//             <div>
//               <InputTag
//                 placeholderText={"Search Product"}
//                 placeholderType={"text"}
//                 padding={"10px"}
//                 fontSize={"12px"}
//                 maxLength={20}
//                 onChange={(e) => setProductSerach(e.target.value)}
//               />
//             </div>
//             <div>
//               <DropDown
//                 label={"Sort By"}
//                 options={[
//                   { label: "Active", value: "Active" },
//                   { label: "Disabled", value: "Disabled" }
//                 ]}
//                 onSelect={(e) => {
//                   setStatusFilter(e.value);
//                   setSortBy(e.value)
//                 }}
//                 onReject={() => setSortBy(null)}
//               />
//             </div>
//             <div>
//               <Button
//                 buttonText={width > 700 ? "Add Product" : ""}
//                 buttonBgColor={"#4164E3"}
//                 buttonTextColor={"#fff"}
//                 buttonIcon={<AddTO />}
//                 buttonClick={() => navi(`/products/addproduct`)}
//               />
//             </div>
//           </div>
//         </div>
//         <div className={styles.container}>
//           <ul className={styles.responsiveTable}>
//             <li
//               className={styles.tableHeader}
//               style={
//                 mode
//                   ? { backgroundColor: "#232529", color: "#fafafa" }
//                   : { backgroundColor: "#D9DCE5" }
//               }
//             >
//               <div className={styles.col}>S/N</div>
//               <div className={styles.col}>Status</div>
//               <div className={styles.col}>Product Name</div>
//               <div className={styles.col}>Delete</div>
//               <div className={styles.col}>Setting</div>
//               <div className={styles.col}>Edit</div>
//               <div className={styles.col}>View</div>
//             </li>
//             <div className={mode ? styles.Table_row : styles.Table_row_light}>
//               {loading.productLoading ? (
//                 <Skeleton lines={10} thickness={5} />
//               ) : filteredData.length === 0 ? (
//                 <NoDataFound icon={<TemplateNotFound />} />
//               ) : (
//                 filteredData.map((item, i) => (
//                   <li className={styles.tablerow}
//                     style={mode ? { backgroundColor: "#1B1D21", color: "#fafafa" }
//                       : { backgroundColor: "#ffff" }}
//                     onClick={() => { navi(`/products/product/${item?.product_name}?product_id=${item?._id}`); }}
//                     key={item._id}>
//                     <div className={styles.col}
//                       data-label="Status">
//                       {i + 1}
//                     </div>
//                     <div className={styles.col}
//                       data-label="Status"
//                       style={{ color: TextColorCode(item?.status) }}>
//                       {item?.status}
//                     </div>
//                     <div className={styles.col}
//                       data-label="Product Name"
//                       style={{ color: mode ? "#fff" : "#000" }}>
//                       {item?.product_name}
//                     </div>
//                     <div className={styles.col}
//                       data-label="Delete"
//                       style={{ color: mode ? "#fff" : "#000" }}>
//                       <span
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleSetModel(
//                             <>
//                               <ManagerModal
//                                 heading={"Delete Product"}
//                                 centerHeading={
//                                   "Are you sure you want to Delete?"
//                                 }
//                                 subHeading={
//                                   "To confirm! type delete in the text field."
//                                 }
//                                 targetWord={"delete"}
//                                 handleSubmit={() => {
//                                   DeleteProduct(item._id);
//                                 }}
//                                 handleCloseModal={() =>
//                                   setToggle({ ...toggle, modelToggle: false })
//                                 }
//                                 loading={loading.productDelete}
//                               />
//                             </>
//                           );
//                         }}
//                       >
//                         <DeleteTo />
//                       </span>
//                     </div>
//                     <div
//                       className={styles.col}
//                       data-label="Setting"
//                       style={{ color: mode ? "#fff" : "#000" }}
//                     >
//                       <SettingTo mode={mode} />
//                     </div>
//                     <div
//                       className={styles.col}
//                       data-label="Edit"
//                       style={{ color: mode ? "#fff" : "#000" }}
//                     >
//                       <span
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           navi(`/products/addproduct?productId=${item?._id}`);
//                         }}
//                       >
//                         <EditeTo />
//                       </span>
//                     </div>
//                     <div
//                       className={styles.col}
//                       data-label="View"
//                       style={{ color: mode ? "#fff" : "#000" }}
//                     >
//                       <ViewTo />
//                     </div>
//                   </li>
//                 ))
//               )}
//             </div>
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// };
// export default Products;














import React, { useEffect, useState } from "react";
import styles from "./Product.module.css";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import { useAuth } from "../../components/context/Auth";
import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
import Button from "../../components/updatedComponents/Dealers/Button";
import { AddTO, DeleteTo, EditeTo, SettingTo, ViewTo } from "../../components/icons/Icon3";
import fetchData from "../../APIsControll/apiControll";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import ManagerModal from "../../components/updatedComponents/Manager/ManagerModal";
import { TextColorCode } from "../../Utils/TextUtils";
import { useNavigate } from "react-router-dom";
import { TemplateNotFound } from "../../components/icons/Icon2";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import useWindowWidth from "../../components/updatedComponents/Hooks/WidthSize";
import { useDispatch, useSelector } from "react-redux";
import {
  setFilteredData, setProductData, setSarchProduct,
  setSortBy, setStatusFilter
} from "../../store/slices/product/ProductSlice";

const Products = () => {
  const { mode, managerId } = useAuth();
  const { show } = useToast();
  const navi = useNavigate();
  const [loading, setLoading] = useState({ productLoading: false, productDelete: false });
  const width = useWindowWidth();
  const [toggle, setToggle] = useState({ modelToggle: false });
  const [modelContainer, setModeContiner] = useState(null);
  const { productSearch, ProductData, filteredData, sortBy, statusFilter } = useSelector((state) => state.product);
  const dispatch = useDispatch();

  const filterAndSort = () => {
    let data = [...ProductData];
    if (productSearch) {
      data = data.filter((product) =>
        product.product_name.toLowerCase().includes(productSearch.toLowerCase())
      );
    }
    if (statusFilter) {
      data = data.filter((product) => product.status === statusFilter);
    }
    if (sortBy) {
      data.sort((a, b) => {
        if (sortBy === "status") {
          return a.status.localeCompare(b.status);
        } else {
          if (a[sortBy] < b[sortBy]) return -1;
          if (a[sortBy] > b[sortBy]) return 1;
          return 0;
        }
      });
    }
    dispatch(setFilteredData(data));
  };

  useEffect(() => {
    filterAndSort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productSearch, sortBy]);

  const getAllProduct = async () => {
    try {
      setLoading({ ...loading, productLoading: true });
      const res = await fetchData(`content/products`);
      if (res.status === "success") {
        dispatch(setProductData(res.data));
        dispatch(setFilteredData(res.data));
        return;
      }
      if (res.status === "failed") {
        show(res.msg, "error");
      }
    } catch (error) {
      show("Error fetching products", "error");
    } finally {
      setLoading({ ...loading, productLoading: false });
    }
  };

  const DeleteProduct = async (id) => {
    try {
      const payload = {
        managerId: managerId,
        _id: id,
      };
      setLoading({ ...loading, productDelete: true });
      const res = await fetchData(`content/deleteProduct`, payload);
      if (res.status === "success") {
        show(res.msg, "success");
        getAllProduct();
        return;
      }
      if (res.status === "failed") {
        show(res.msg, "error");
        return;
      }
    } catch (error) {
      show("Something went wrong", "error");
    } finally {
      setLoading({ ...loading, productDelete: false });
    }
  };

  useEffect(() => {
    getAllProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId]);

  const handleSetModel = (con) => {
    setToggle({ ...toggle, modelToggle: true });
    setModeContiner(con);
  };

  return (
    <div className={styles.Main_Layout}>
      <ModalWrapper
        isOpen={toggle.modelToggle}
        onClose={() => setToggle({ ...toggle, modelToggle: !toggle.modelToggle })}
      >
        {modelContainer}
      </ModalWrapper>

      <div className={styles.Layout}
        style={{ backgroundColor: mode ? "#2B2D31" : "#F8F9FC" }}
      >
        <div className={styles.Top_bar_css}>
          <div className={styles.gobackClass}>
            <TopTabBar text={"Product"} />
          </div>
          <div className={styles.btn_Continer}>
            <div>
              <InputTag
                placeholderText={"Search Product"}
                placeholderType={"text"}
                padding={"10px"}
                fontSize={"12px"}
                maxLength={20}
                value={productSearch}
                onChange={(e) => dispatch(setSarchProduct(e.target.value))}
              />
            </div>
            <div>
              <DropDown
                label={"Sort By"}
                options={[
                  { label: "Active", value: "Active" },
                  { label: "Delete", value: "Delete" }
                ]}
                onSelect={(e) => {
                  dispatch(setStatusFilter(e.value));
                  dispatch(setSortBy(e.value))
                }}
                onReject={() => dispatch(setSortBy(null))}
              />
            </div>
            <div>
              <Button
                buttonText={width > 700 ? "Add Product" : ""}
                buttonBgColor={"#4164E3"}
                buttonTextColor={"#fff"}
                buttonIcon={<AddTO />}
                buttonClick={() => navi(`/products/addproduct`)}
              />
            </div>
          </div>
        </div>
        <div className={styles.container}>
          <ul className={styles.responsiveTable}>
            <li
              className={styles.tableHeader}
              style={mode ?
                { backgroundColor: "#232529", color: "#fafafa" }
                : { backgroundColor: "#D9DCE5" }
              }>
              <div className={styles.col}>S/N</div>
              <div className={styles.col}>Status</div>
              <div className={styles.col}>Product Name</div>
              <div className={styles.col}>Delete</div>
              <div className={styles.col}>Setting</div>
              <div className={styles.col}>Edit</div>
              <div className={styles.col}>View</div>
            </li>
            <div className={mode ? styles.Table_row : styles.Table_row_light}>
              {loading.productLoading ? (
                <Skeleton lines={10} thickness={5} />
              ) : filteredData.length === 0 ? (
                <NoDataFound icon={<TemplateNotFound />} />
              ) : (
                filteredData.map((item, i) => (
                  <li className={styles.tablerow}
                    style={mode ? { backgroundColor: "#1B1D21", color: "#fafafa" }
                      : { backgroundColor: "#ffff" }}
                    onClick={() => { navi(`/products/product/${item?.product_name}?product_id=${item?._id}`); }}
                    key={item._id}>
                    <div className={styles.col}
                      data-label="Status">
                      {i + 1}
                    </div>
                    <div className={styles.col}
                      data-label="Status"
                      style={{ color: TextColorCode(item?.status) }}>
                      {item?.status}
                    </div>
                    <div className={styles.col}
                      data-label="Product Name"
                      style={{ color: mode ? "#fff" : "#000" }}>
                      {item?.product_name}
                    </div>
                    <div className={styles.col}
                      data-label="Delete"
                      style={{ color: mode ? "#fff" : "#000" }}>
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSetModel(
                            <>
                              <ManagerModal
                                heading={"Delete Product"}
                                centerHeading={"Are you sure you want to Delete?"}
                                subHeading={"To confirm! type delete in the text field."}
                                targetWord={"delete"}
                                handleSubmit={() => {
                                  DeleteProduct(item._id);
                                }}
                                handleCloseModal={() =>
                                  setToggle({ ...toggle, modelToggle: false })
                                }
                                loading={loading.productDelete}
                              />
                            </>
                          )
                        }}>
                        <DeleteTo />
                      </span>
                    </div>
                    <div className={styles.col}
                      data-label="Setting"
                      style={{ color: mode ? "#fff" : "#000" }}
                    >
                      <SettingTo mode={mode} />
                    </div>
                    <div className={styles.col}
                      data-label="Edit"
                      style={{ color: mode ? "#fff" : "#000" }}
                    >
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          navi(`/products/addproduct?productId=${item?._id}`);
                        }}
                      >
                        <EditeTo />
                      </span>
                    </div>
                    <div
                      className={styles.col}
                      data-label="View"
                      style={{ color: mode ? "#fff" : "#000" }}
                    >
                      <ViewTo />
                    </div>
                  </li>
                ))
              )}
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Products;